<template>
	<div v-if="show" :class="slideInClass">
		<header>
			<div class="jon">
				<Jon/>
			</div>
		</header>
		<main id="job-questionnaire-main" class="scrollbar-check" ref="main">
			<Loading v-if="loading"/>
			<div v-else>
				<div v-if="allDone" class="all-done">
					<Avatar :avatar="avatarRocket"/>
					<div class="all-done-text">
						<p>Yeah, super, du hast alles erledigt!</p>
						<p v-if="publishedJob">Dein anonymes Profil kann nun von Firmen gefunden werden.</p>
					</div>
				</div>
				<BreakDisplay
					v-else-if="breakType"
					:type="breakType"
				/>
				<template v-else>
					<div
						:class="{'d-none': i !== indexToEdit}"
						v-for="(item, i) in questionnaire.items"
						:key="item.id"
						class="item-container"
					>
						<template v-if="showMessages">
							<div v-if="forcedMessages" class="messages">
								<div
									v-for="(message, j) in forcedMessages"
									:key="'forced-message--' + j"
									:style="{'animation-delay': (j + 's')}"
									class="message"
								>
									<span v-html="message"/>
								</div>
							</div>
							<div v-else class="messages">
								<div
									v-for="(message, j) in getMessages(item.id)"
									:key="'message--' + item.id + '--' + j"
									:style="{'animation-delay': (j + 's')}"
									class="message"
								>
									<span v-html="message"/>
								</div>
							</div>
						</template>
						<div
							:class="[
								'item-edit',
								item.id, i === indexToEdit ? 'current' : undefined,
								skip ? 'skip' : undefined
							]"
							:style="{'animation-delay': showMessages ? (getMessages(item.id).length + 's') : '0s'}"
						>
							<CareerChangeFunction
								v-if="isItemToEdit('career-change-function', i)"
								:class="{'d-none': item.id !== 'career-change-function'}"
								:value="getItemData('career-change-function')"
								:initial-functions="job.functions"
								@input="setItemData('career-change-function', $event)"
							/>
							<CareerChangeIndustrialSector
								v-if="isItemToEdit('career-change-industrial-sector', i)"
								:class="{'d-none': item.id !== 'career-change-industrial-sector'}"
								:value="getItemData('career-change-industrial-sector')"
								:initial-industrial-sectors="job.industrialSectors"
								@input="setItemData('career-change-industrial-sector', $event)"
							/>
							<WorkingHours
								v-if="isItemToEdit('working-hours', i)"
								:class="{'d-none': item.id !== 'working-hours'}"
								:value="getItemData('working-hours')"
								@input="setItemData('working-hours', $event)"
							/>
							<EmploymentDuration
								v-if="isItemToEdit('employment-duration', i)"
								:class="{'d-none': item.id !== 'employment-duration'}"
								:value="getItemData('employment-duration')"
								@input="setItemData('employment-duration', $event)"
							/>
							<StartDate
								v-if="isItemToEdit('start-date', i)"
								:class="{'d-none': item.id !== 'start-date'}"
								:value="getItemData('start-date')"
								@input="setItemData('start-date', $event)"
							/>
							<CharacteristicEdit
								v-if="isItemToEdit('function-assistance', i)"
								:class="{'d-none': item.id !== 'function-assistance'}"
								:value="getItemData('function-assistance')"
								title="Assistenz-Tätigkeiten - Gib möglichst alles an, was dich grundlegend interessiert und auch Teil deiner Tätigkeit sein kann. Das erhöht deine Chancen!"
								with-keyword
								:characteristic-type="meta.functionAssistanceType"
								:characteristic-items="meta.functionAssistance"
								:nothing-allowed="{
									onlyOverall: true,
									overall: {
										text: 'Mir sind alle Tätigkeiten recht',
										inFan: true
									}
								}"
								open-fan-label="Assistenz-Tätigkeiten auswählen"
								open-fan-label-with-selection="Assistenz-Tätigkeiten bearbeiten"
								@input="setItemData('function-assistance', $event)"
							/>
							<CharacteristicEdit
								v-if="isItemToEdit('function-marketing-role', i)"
								:class="{'d-none': item.id !== 'function-marketing-role'}"
								:value="getItemData('function-marketing-role')"
								title="Marketing-Tätigkeiten - Gib möglichst alles an, was dich grundlegend interessiert und auch Teil deiner Tätigkeit sein kann. Das erhöht deine Chancen!"
								with-keyword
								:characteristic-type="meta.functionMarketingRoleType"
								:characteristic-items="meta.functionMarketingRole"
								:nothing-allowed="{
									onlyOverall: true,
									overall: {
										text: 'Mir sind alle Tätigkeiten recht',
										inFan: true
									}
								}"
								open-fan-label="Marketing-Tätigkeiten auswählen"
								open-fan-label-with-selection="Marketing-Tätigkeiten bearbeiten"
								@input="setItemData('function-marketing-role', $event)"
							/>
							<CharacteristicEdit
								v-if="isItemToEdit('function-legal-field', i)"
								:class="{'d-none': item.id !== 'function-legal-field'}"
								:value="getItemData('function-legal-field')"
								title="Welche Rechtsgebiete möchtest du:"
								with-keyword
								:characteristic-type="meta.functionLegalFieldType"
								:characteristic-items="meta.functionLegalField"
								:nothing-allowed="{
									onlyOverall: true,
									overall: {
										text: 'Es sind alle Rechtsgebiete möglich',
										inFan: true
									}
								}"
								open-fan-label="Rechtsgebiete auswählen"
								open-fan-label-with-selection="Rechtsgebiete bearbeiten"
								@input="setItemData('function-legal-field', $event)"
							/>
							<CharacteristicEdit
								v-if="isItemToEdit('function-legal-role', i)"
								:class="{'d-none': item.id !== 'function-legal-role'}"
								:value="getItemData('function-legal-role')"
								title="Welche Rechtstätigkeiten möchtest du:"
								with-keyword
								:characteristic-type="meta.functionLegalRoleType"
								:characteristic-items="meta.functionLegalRole"
								:nothing-allowed="{
									onlyOverall: true,
									overall: {
										text: 'Es sind alle Rechtstätigkeiten möglich',
										inFan: true
									}
								}"
								open-fan-label="Rechtstätigkeiten auswählen"
								open-fan-label-with-selection="Rechtstätigkeiten bearbeiten"
								@input="setItemData('function-legal-role', $event)"
							/>
							<CharacteristicEdit
								v-if="isItemToEdit('function-tax-field', i)"
								:class="{'d-none': item.id !== 'function-tax-field'}"
								:value="getItemData('function-tax-field')"
								title="Welche Steuergebiete möchtest du:"
								with-keyword
								:characteristic-type="meta.functionTaxFieldType"
								:characteristic-items="meta.functionTaxField"
								:nothing-allowed="{
									onlyOverall: true,
									overall: {
										text: 'Es sind alle Steuergebiete möglich',
										inFan: true
									}
								}"
								open-fan-label="Steuergebiete auswählen"
								open-fan-label-with-selection="Steuergebiete bearbeiten"
								@input="setItemData('function-tax-field', $event)"
							/>
							<CharacteristicEdit
								v-if="isItemToEdit('function-tax-role', i)"
								:class="{'d-none': item.id !== 'function-tax-role'}"
								:value="getItemData('function-tax-role')"
								title="Welche Steuertätigkeiten möchtest du:"
								with-keyword
								:characteristic-type="meta.functionTaxRoleType"
								:characteristic-items="meta.functionTaxRole"
								:nothing-allowed="{
									onlyOverall: true,
									overall: {
										text: 'Es sind alle Steuertätigkeiten möglich',
										inFan: true
									}
								}"
								open-fan-label="Steuertätigkeiten auswählen"
								open-fan-label-with-selection="Steuertätigkeiten bearbeiten"
								@input="setItemData('function-tax-role', $event)"
							/>
							<DesireAdditions
								v-if="isItemToEdit('experience-function', i)"
								sub-title="Zu deinem Jobwunsch/Tätigkeitswunsch:"
								:class="{'d-none': item.id !== 'experience-function'}"
								:characteristic-type="meta.functionType"
								:characteristic-items="meta.function"
								:desire="job.functions"
								:value="getItemData('experience-function')"
								:addition-config="{
									inline: true,
									subTitle: 'Zu deiner Tätigkeitserfahrung:',
									experience: {
										enabled: true,
										noneAllowed: true
									},
									education: {
										enabled: false
									}
								}"
								:supplements-config="{
									nothingAllowed: false,
									types: functionSupplementTypes
								}"
								:further-messages="[
									'Hast du bisher weitere Tätigkeitserfahrungen gesammelt?<br/>Egal, ob privat oder beruflich! &#128512;',
									'Wichtig: Je mehr du angibst, desto höher deine Chancen.<br />Wieso? Arbeitgeber entscheiden zumeist danach, welche Erfahrungen insgesamt bisher gesammelt wurden und was man sonst noch kann. &#128076;'
								]"
								:label-type="labelTypeApplication"
								@furtherAppeared="addDisableSkip('experience-function')"
								@additionsEdit="onDesireAdditionsEdit"
								@input="setItemData('experience-function', $event)"
							>
								<template #deleteConfirmText="data">
									Möchtest du die Tätigkeits-Erfahrung
									<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
									wirklich entfernen?
								</template>
							</DesireAdditions>
							<DesireAdditions
								v-if="isItemToEdit('experience-function-legal-field', i)"
								:class="{'d-none': item.id !== 'experience-function-legal-field'}"
								:characteristic-type="meta.functionLegalFieldType"
								:characteristic-items="meta.functionLegalField"
								:desire="[]"
								:value="getItemData('experience-function-legal-field')"
								:addition-config="{
									inline: true,
									subTitle: 'Zu deiner Rechtsgebiets-Erfahrung:',
									experience: {
										enabled: true,
										noneAllowed: true
									},
									education: {
										enabled: false
									}
								}"
								:label-type="labelTypeApplication"
								@furtherAppeared="addDisableSkip('experience-function-legal-field')"
								@additionsEdit="onDesireAdditionsEdit"
								@input="setItemData('experience-function-legal-field', $event)"
							>
								<template #deleteConfirmText="data">
									Möchtest du die Rechtsgebiets-Erfahrung
									<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
									wirklich entfernen?
								</template>
							</DesireAdditions>
							<DesireAdditions
								v-if="isItemToEdit('experience-function-legal-role', i)"
								:class="{'d-none': item.id !== 'experience-function-legal-role'}"
								:characteristic-type="meta.functionLegalRoleType"
								:characteristic-items="meta.functionLegalRole"
								:desire="[]"
								:value="getItemData('experience-function-legal-role')"
								:addition-config="{
									inline: true,
									subTitle: 'Zu deiner Rechtstätigkeits-Erfahrung:',
									experience: {
										enabled: true
									},
									education: {
										enabled: false
									}
								}"
								:label-type="labelTypeApplication"
								@furtherAppeared="addDisableSkip('experience-function-legal-role')"
								@additionsEdit="onDesireAdditionsEdit"
								@input="setItemData('experience-function-legal-role', $event)"
							>
								<template #deleteConfirmText="data">
									Möchtest du die Rechtstätigkeits-Erfahrung
									<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
									wirklich entfernen?
								</template>
							</DesireAdditions>
							<DesireAdditions
								v-if="isItemToEdit('experience-function-marketing-role', i)"
								:class="{'d-none': item.id !== 'experience-function-marketing-role'}"
								:characteristic-type="meta.functionMarketingRoleType"
								:characteristic-items="meta.functionMarketingRole"
								:desire="[]"
								:value="getItemData('experience-function-marketing-role')"
								:addition-config="{
									inline: true,
									subTitle: 'Zu deiner Marketingtätigkeits-Erfahrung:',
									experience: {
										enabled: true
									},
									education: {
										enabled: false
									}
								}"
								:label-type="labelTypeApplication"
								@furtherAppeared="addDisableSkip('experience-function-marketing-role')"
								@additionsEdit="onDesireAdditionsEdit"
								@input="setItemData('experience-function-marketing-role', $event)"
							>
								<template #deleteConfirmText="data">
									Möchtest du die Marketingtätigkeits-Erfahrung
									<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
									wirklich entfernen?
								</template>
							</DesireAdditions>
							<DesireAdditions
								v-if="isItemToEdit('experience-function-tax-field', i)"
								:class="{'d-none': item.id !== 'experience-function-tax-field'}"
								:characteristic-type="meta.functionTaxFieldType"
								:characteristic-items="meta.functionTaxField"
								:desire="[]"
								:value="getItemData('experience-function-tax-field')"
								:addition-config="{
									inline: true,
									subTitle: 'Zu deiner Steuergebiet-Erfahrung:',
									experience: {
										enabled: true,
										noneAllowed: true
									},
									education: {
										enabled: false
									}
								}"
								:label-type="labelTypeApplication"
								@furtherAppeared="addDisableSkip('experience-function-tax-field')"
								@additionsEdit="onDesireAdditionsEdit"
								@input="setItemData('experience-function-tax-field', $event)"
							>
								<template #deleteConfirmText="data">
									Möchtest du die Steuergebiet-Erfahrung
									<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
									wirklich entfernen?
								</template>
							</DesireAdditions>
							<DesireAdditions
								v-if="isItemToEdit('experience-function-tax-role', i)"
								:class="{'d-none': item.id !== 'experience-function-tax-role'}"
								:characteristic-type="meta.functionTaxRoleType"
								:characteristic-items="meta.functionTaxRole"
								:desire="[]"
								:value="getItemData('experience-function-tax-role')"
								:addition-config="{
									inline: true,
									subTitle: 'Zu deiner Steuertätigkeits-Erfahrung:',
									experience: {
										enabled: true,
										noneAllowed: true
									},
									education: {
										enabled: false
									}
								}"
								:label-type="labelTypeApplication"
								@furtherAppeared="addDisableSkip('experience-function-tax-role')"
								@additionsEdit="onDesireAdditionsEdit"
								@input="setItemData('experience-function-tax-role', $event)"
							>
								<template #deleteConfirmText="data">
									Möchtest du die Steuerstätigkeits-Erfahrung
									<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
									wirklich entfernen?
								</template>
							</DesireAdditions>
							<DesireAdditions
								v-if="isItemToEdit('experience-career-level', i)"
								sub-title="Zu deinem Wunsch der Berufsebene:"
								:class="{'d-none': item.id !== 'experience-career-level'}"
								:characteristic-type="meta.careerLevelType"
								:characteristic-items="meta.careerLevel"
								:desire="job.careerLevels"
								:value="getItemData('experience-career-level')"
								:addition-config="{
									inline: true,
									subTitle: 'Zu deiner Berufsebenen-Erfahrung:',
									experience: {
										enabled: true,
										noneAllowed: true
									},
									education: {
										enabled: false
									}
								}"
								:group-by-letter="{
									enabled: false
								}"
								button-text="Erfahrung eingeben"
								:further-messages="[
									'Hast du bisher weitere Arbeitserfahrungen gesammelt?',
									'Wichtig: Je mehr du angibst, desto höher deine Chancen für den passenden Job. &#128077;'
								]"
								:further-messages-empty="[
									'Hast du bisher Arbeitserfahrungen gesammelt?',
									'Wichtig: Je mehr du angibst, desto höher deine Chancen für den passenden Job. &#128077;'
								]"
								:label-type="labelTypeApplication"
								@furtherAppeared="desireAdditionsFurtherAppeared('experience-career-level', $event)"
								@additionsEdit="onDesireAdditionsEdit"
								@input="setItemData('experience-career-level', $event)"
							>
								<template #deleteConfirmText="data">
									Möchtest du die Berufsebenen-Erfahrung
									<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
									wirklich entfernen?
								</template>
							</DesireAdditions>
							<Parking
								v-if="isItemToEdit('parking', i)"
								:class="{'d-none': item.id !== 'parking'}"
								:value="getItemData('parking')"
								@input="setItemData('parking', $event)"
							/>
							<DesireAdditions
								v-if="isItemToEdit('experience-industrial-sector', i)"
								sub-title="Zu deinem Wunsch der Branche deines Arbeitgebers:"
								:class="{'d-none': item.id !== 'experience-industrial-sector'}"
								:characteristic-type="meta.industrialSectorType"
								:characteristic-items="meta.industrialSector"
								:desire="job.industrialSectors"
								:value="getItemData('experience-industrial-sector')"
								:addition-config="{
									inline: true,
									subTitle: 'Zu deiner Branchen-Erfahrung:',
									experience: {
										enabled: true,
										noneAllowed: true
									},
									education: {
										enabled: false
									}
								}"
								:further-messages="[
									'Hast du bisher weitere Branchen-Erfahrungen gesammelt?',
									'Wichtig: Je mehr du angibst, desto höher deine Chancen für den passenden Job. &#128077;'
								]"
								:label-type="labelTypeApplication"
								@furtherAppeared="addDisableSkip('experience-industrial-sector')"
								@additionsEdit="onDesireAdditionsEdit"
								@input="setItemData('experience-industrial-sector', $event)"
							>
								<template #deleteConfirmText="data">
									Möchtest du die Branchen-Erfahrung
									<Label :characteristic="data.item.item" class="font-weight-extra-bold"/>
									wirklich entfernen?
								</template>
							</DesireAdditions>
							<SelectInline
								v-if="isItemToEdit('company-type', i)"
								:class="{'d-none': item.id !== 'company-type'}"
								:value="getItemData('company-type')"
								multiple
								initial-show-all
								:characteristic-items="meta.companyType"
								:nothing-allowed="{
									text: 'Ich bevorzuge keine bestimmte Art'
								}"
								show-multiple-hint
								@input="setItemData('company-type', $event)"
							/>
							<SelectInline
								v-if="isItemToEdit('company-size', i)"
								:class="{'d-none': item.id !== 'company-size'}"
								:value="getItemData('company-size')"
								multiple
								initial-show-all
								:characteristic-items="meta.companySize"
								:nothing-allowed="{
									text: 'Ich bevorzuge keine bestimmte Größe'
								}"
								show-multiple-hint
								@input="setItemData('company-size', $event)"
							/>
							<DesireExperience
								v-if="isItemToEdit('management', i)"
								:class="{'d-none': item.id !== 'management'}"
								:value="getItemData('management')"
								:characteristic-items="meta.managementKind"
								@input="setItemData('management', $event)"
							>
								<template #yes-text>Welche Führungsverantwortung möchtest du übernehmen?</template>
							</DesireExperience>
							<Overtime
								v-if="isItemToEdit('overtime', i)"
								:class="{'d-none': item.id !== 'overtime'}"
								:value="getItemData('overtime')"
								@input="setItemData('overtime', $event)"
							/>
							<WorkingTime
								v-if="isItemToEdit('working-time', i)"
								:class="{'d-none': item.id !== 'working-time'}"
								:value="getItemData('working-time')"
								@input="setItemData('working-time', $event)"
							/>
							<Languages
								v-if="isItemToEdit('languages', i)"
								:class="{'d-none': item.id !== 'languages'}"
								:value="getItemData('languages')"
								:meta="meta"
								@input="setItemData('languages', $event)"
							/>
							<SelectInline
								v-if="isItemToEdit('skills-software-main', i)"
								:class="{'d-none': item.id !== 'skills-software-main'}"
								:value="getItemData('skills-software-main')"
								:characteristic-items="meta.skillSoftwareMain"
								:nothing-allowed="{
									text: 'Ich habe noch keine Erfahrung mit Büro-Software'
								}"
								with-self-assessment
								@input="setItemData('skills-software-main', $event)"
							/>
							<SkillsSoftwareSpecial
								v-if="isItemToEdit('skills-software-special', i)"
								:class="{'d-none': item.id !== 'skills-software-special'}"
								with-info-text
								:value="getItemData('skills-software-special')"
								@input="setItemData('skills-software-special', $event)"
							/>
							<DesireExperience
								v-if="isItemToEdit('customer-contact', i)"
								:class="{'d-none': item.id !== 'customer-contact'}"
								:value="getItemData('customer-contact')"
								:characteristic-items="meta.businessModel"
								@input="setItemData('customer-contact', $event)"
							>
								<template #info-text>
									Wähle aus, ob du Kundenkontakt möchtest.
								</template>
								<template #yes-text>
									Mit welchen Kunden hättest du gerne Kontakt? Und hast du darin bereits Erfahrung
									gesammelt?
								</template>
								<template #irrelevant-text>
									Gib an, wenn du bereits Erfahrung gesammelt hast. Das erhöht deine Chancen!
								</template>
							</DesireExperience>
							<PublicTransport
								v-if="isItemToEdit('public-transport', i)"
								:class="{'d-none': item.id !== 'public-transport'}"
								:value="getItemData('public-transport')"
								@input="setItemData('public-transport', $event)"
							/>
							<CompanyCar
								v-if="isItemToEdit('company-car', i)"
								:class="{'d-none': item.id !== 'company-car'}"
								:value="getItemData('company-car')"
								@input="setItemData('company-car', $event)"
							/>
							<PrivateVehicleCompanyUsage
								v-if="isItemToEdit('private-vehicle-company-usage', i)"
								:class="{'d-none': item.id !== 'private-vehicle-company-usage'}"
								:value="getItemData('private-vehicle-company-usage')"
								@input="setItemData('private-vehicle-company-usage', $event)"
							/>
							<SelectInline
								v-if="isItemToEdit('driving-license', i)"
								:class="{'d-none': item.id !== 'driving-license'}"
								:value="getItemData('driving-license')"
								:characteristic-items="meta.drivingLicenseClass"
								:characteristic-type="meta.drivingLicenseClassType"
								:nothing-allowed="{
									text: 'Ich habe keinen Führerschein'
								}"
								icon-path="/img/characteristic/driving-license"
								:description-config="{
									inline: true
								}"
								initial-show-all
								show-multiple-hint
								@input="setItemData('driving-license', $event)"
							/>
							<SelectInline
								v-if="isItemToEdit('pilot-license', i)"
								:class="{'d-none': item.id !== 'pilot-license'}"
								:value="getItemData('pilot-license')"
								:characteristic-items="meta.pilotLicense"
								:nothing-allowed="{
									text: 'Leider nicht ... Ich besitze keinen Flugschein'
								}"
								show-multiple-hint
								initial-show-all
								@input="setItemData('pilot-license', $event)"
							/>
							<Salary
								v-if="isItemToEdit('salary', i)"
								:class="{'d-none': item.id !== 'salary'}"
								:value="getItemData('salary')"
								:employment-modes="employmentModes"
								@input="setItemData('salary', $event)"
							/>
							<HourlyRate
								v-if="isItemToEdit('hourly-rate', i)"
								:class="{'d-none': item.id !== 'hourly-rate'}"
								:value="getItemData('hourly-rate')"
								@input="setItemData('hourly-rate', $event)"
							/>
							<Skills
								v-if="isItemToEdit('skills', i)"
								:class="{'d-none': item.id !== 'skills'}"
								:value="getItemData('skills')"
								@input="setItemData('skills', $event)"
							/>
							<TravelWillingness
								v-if="isItemToEdit('travel-willingness', i)"
								:class="{'d-none': item.id !== 'travel-willingness'}"
								:meta="meta"
								:value="getItemData('travel-willingness')"
								@input="setItemData('travel-willingness', $event)"
							/>
							<Relocation
								v-if="isItemToEdit('relocation', i)"
								:class="{'d-none': item.id !== 'relocation'}"
								:value="getItemData('relocation')"
								@input="setItemData('relocation', $event)"
							/>
							<SearchStatus
								v-if="isItemToEdit('search-status', i)"
								:class="{'d-none': item.id !== 'search-status'}"
								:value="getItemData('search-status')"
								questionnaire
								@input="setItemData('search-status', $event)"
							/>
							<Education
								v-if="isItemToEdit('education', i)"
								:class="{'d-none': item.id !== 'education'}"
								:value="getItemData('education')"
								@furtherAppeared="addDisableSkip('education')"
								@educationsChanged="onEducationsChanged"
								@input="setItemData('education', $event)"
							/>
							<Legitimation
								v-if="item.id === 'legitimation'"
								:value="getItemData('legitimation')"
								:meta="meta"
								:job="job"
								:item="item"
								@mustConfirmMobilePhone="confirmMobilePhone = $event"
								@revertMobilePhoneConfirmation="confirmMobilePhone = undefined"
								@input="setItemData('legitimation', $event)"
								@finish="onFinishLegitimation"
							/>
						</div>
					</div>
				</template>
			</div>
		</main>
		<footer v-if="!isLegitimation" class="align-items-baseline">
			<div class="footer--button-container">
				<div class="flex-grow-1">
					<Button
						v-if="indexToEdit > 0 && !loading && !allDone && !hideGoBack"
						text="Zurück"
						secondary
						:disabled="!canGoBack || finishingItem"
						@click="goBack"
					/>
				</div>
				<div class="text-md-right">
					<Button
						v-if="allDone && publishedJob"
						text="Zu den Matches"
						icon="checkmark"
						href="/kandidat/profil/jobs?trackPageVisitEvent=1"
					/>
					<Button
						v-if="allDone && !publishedJob"
						text="Schließen"
						icon="checkmark"
						@click="close"
					/>
					<div v-if="!loading && !allDone" class="d-flex align-items-center justify-content-end flex-column-reverse flex-md-row">
						<b-form-checkbox
							v-if="!loading && canSkip"
							v-model="skip"
							:value="true"
							class="d-none d-md-block mr-2 mt-2 mt-md-0"
						>
							Ich möchte diese Frage später beantworten.
						</b-form-checkbox>
						<Button
							text="Weiter"
							icon="checkmark"
							:disabled="!canContinue || finishingItem"
							:loading="finishingItem"
							@click="finishItem(true)"
						/>
					</div>
					<div class="d-none d-md-block font-size-smaller mt-3">
						Alle deine Angaben können nachträglich noch geändert werden.
					</div>
				</div>
			</div>
			<div class="d-md-none mt-2">
				<b-form-checkbox
					v-if="!loading && canSkip"
					v-model="skip"
					:value="true"
				>
					Ich möchte diese Frage später beantworten.
				</b-form-checkbox>
				<div class="font-size-smaller mt-3">
					Alle deine Angaben können nachträglich noch geändert werden.
				</div>
			</div>
			<!-- Deactivated for the start -->
			<!--<div class="continue-later">
				<Button
					v-if="!hasUnfinishedPreListingItems && !isLastStep && !allDone"
					text="Genug, zeig mir Ergebnisse, frag mich später weiter!"
					secondary
					icon="close"
					@click="continueLater"
				/>
			</div>-->
		</footer>
		<PopUp
			v-if="showSkipWarningPopUp"
			title="Hinweis"
			hide-close
			cancel-text="Trotzdem überspringen"
			ok-text="Jetzt vervollständigen"
			@ok="onAcceptSkipWarning"
			@hidden="onCancelSkipWarning"
		>
			<JonInfo>
				<template #message>
					Wenn Du deine Erfahrungen nicht vollständig eingibst, wirst du kaum Matches erhalten.
				</template>
			</JonInfo>
		</PopUp>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Legitimation from "@/vue/application/Legitimation"
import Icon from "@/vue/icon/Icon";
import Get from "@/api/job/questionnaire/Get";
import Loading from "@/vue/common/Loading";
import Button from "@/vue/common/Button";
import CharacteristicEdit from "@/vue/characteristic/Edit";
import Overtime from "@/vue/application/Overtime";
import StartDate from "@/vue/application/StartDate";
import Experience from "@/vue/application/Experience";
import JobSave from "@/api/job/Save";
import ApplicationSkillsSave from "@/api/application/skills/Save";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import * as Preparation from "@/helper/application/Preparation"
import SelectInline from "@/vue/characteristic/SelectInline";
import WorkingTime from "@/vue/application/WorkingTime";
import Languages from "@/vue/application/Languages";
import CustomerContact from "@/vue/application/CustomerContact";
import CompanyCar from "@/vue/application/CompanyCar";
import PublicTransport from "@/vue/application/PublicTransport";
import PrivateVehicleCompanyUsage from "@/vue/application/PrivateVehicleCompanyUsage";
import Salary from "@/vue/application/Salary";
import HourlyRate from "@/vue/application/HourlyRate";
import _ from "lodash";
import TravelWillingness from "@/vue/application/TravelWillingness";
import ExternalSleepover from "@/vue/application/ExternalSleepover";
import Relocation from "@/vue/application/Relocation";
import SearchStatus from "@/vue/application/SearchStatus";
import WorkingHours from "@/vue/application/WorkingHours";
import CareerChangeFunction from "@/vue/application/CareerChangeFunction";
import CareerChangeIndustrialSector from "@/vue/application/CareerChangeIndustrialSector";
import EmploymentDuration from "@/vue/application/EmploymentDuration";
import * as CharacteristicLabel from "@/helper/characteristic/Label";
import * as Section from "@/helper/application/Section";
import Skills from "@/vue/application/Skills";
import SkillsSoftwareSpecial from "@/vue/application/SkillsSoftwareSpecial";
import DesireExperience from "@/vue/characteristic/DesireExperience";
import * as Log from "@/helper/Log";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job/bot";
import DesireAdditions from "@/vue/characteristic/DesireAdditions.vue";
import Parking from "@/vue/application/Parking.vue";
import BreakDisplay, {TYPE__PRE_EXPERIENCE} from "./questionnaire/BreakDisplay"
import Label from "@/vue/characteristic/Label.vue";
import Education from "@/vue/application/Education.vue";
import Jon from "@/vue/common/image/Jon.vue";
import Avatar, {ROCKET} from "@/vue/common/image/Avatar.vue";
import {scrollToBottom} from "@/helper/Window";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";
import {RELEVANT_SUPPLEMENT_TYPES} from "@/helper/characteristic/Functions";
import PopUp from "@/vue/common/PopUp.vue";
import JonInfo from "@/vue/common/JonInfo.vue";

const PERSIST_TYPE__JOB = 'job';
const PERSIST_TYPE__APPLICANT = 'applicant';

const CONFIG = {
	[Section.WORKING_HOURS]: {
		property: 'workingHours',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Wie viele Stunden pro Woche möchtest du bei Teilzeit arbeiten?',
		],
	},
	[Section.CAREER_CHANGE_FUNCTION]: {
		property: 'careerChangeFunction',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) =>
		{
			return {
				functions: Preparation.prepareCharacteristic(itemData.functions),
				finished: true,
			};
		},
		messages: [
			'Wie wäre es mit einem Quereinstieg? - Der bietet viele Chancen!',
			'Oder möchtest du etwas kennenlernen?',
			'Wenn du eine entsprechende Einarbeitung und Einschulung erhältst: welche anderen Jobs würden dich noch interessieren?'
		]
	},
	[Section.CAREER_CHANGE_INDUSTRIAL_SECTOR]: {
		property: 'careerChangeIndustrialSector',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) =>
		{
			return {
				industrialSectors: Preparation.prepareCharacteristic(itemData.industrialSectors),
				finished: true,
			};
		},
		messages: [
			'Und welche Branchen würden dich noch interessieren? Wenn du dort gut eingeschult und eingearbeitet wirst?',
		]
	},
	[Section.EMPLOYMENT_DURATION]: {
		property: 'employmentDuration',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Wie lange soll das Praktikum dauern?',
		],
	},
	[Section.START_DATE]: {
		property: 'startDate',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Ab wann kannst du den Job beginnen?',
			'Arbeitgeber sehen nur, dass du verfügbar bist, nicht seit wann du suchst.'
		]
	},
	[Section.FUNCTION_ASSISTANCE]: {
		property: 'functionAssistance',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareCharacteristicWithExperience(itemData),
		messages: [
			'Welche Assistenz-Tätigkeiten willst du?',
		],
	},
	[Section.FUNCTION_MARKETING_ROLE]: {
		property: 'functionMarketingRole',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareCharacteristicWithExperience(itemData),
		messages: [
			'Welche Marketing-Tätigkeiten willst du?',
		],
	},
	[Section.FUNCTION_LEGAL_FIELD]: {
		property: 'functionLegalField',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareCharacteristicWithExperience(itemData),
		messages: [
			'Welche Rechtsgebiete willst du?',
		],
	},
	[Section.FUNCTION_LEGAL_ROLE]: {
		property: 'functionLegalRole',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareCharacteristicWithExperience(itemData),
		messages: [
			'Welche Rechtstätigkeiten willst du?',
		],
	},
	[Section.FUNCTION_TAX_FIELD]: {
		property: 'functionTaxField',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareCharacteristicWithExperience(itemData),
		messages: [
			'Welche Steuergebiete willst du?',
		],
	},
	[Section.FUNCTION_TAX_ROLE]: {
		property: 'functionTaxRole',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareCharacteristicWithExperience(itemData),
		messages: [
			'Welche Steuertätigkeiten willst du?',
		],
	},
	[Section.EXPERIENCE_FUNCTION]: {
		property: 'experienceFunction',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData, skip) => Preparation.prepareExperienceSkippable(itemData, skip),
		showSkipWarning: true,
		messages: [
			'Gib bitte <b>zu deinen Jobwünschen</b> an, ob du darin <b>Erfahrungen</b> hast und <b>wie gut</b> du es kannst.',
			'Keine Sorge! &#128521;<br />Auch, wenn du noch keine Erfahrungen hast, oder du etwas noch nicht kannst: ' +
			'Viele Arbeitgeber suchen Einsteiger oder Quereinsteiger und vor allem zählt dein Wunsch und Engagement. &#128077;',
		],
	},
	[Section.EXPERIENCE_FUNCTION_LEGAL_FIELD]: {
		property: 'experienceFunctionLegalField',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData, skip) => Preparation.prepareExperienceSkippable(itemData, skip),
		messages: [
			'Hast du bereits Erfahrung in bestimmten Rechtsgebieten gesammelt?'
		],
	},
	[Section.EXPERIENCE_FUNCTION_LEGAL_ROLE]: {
		property: 'experienceFunctionLegalRole',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData, skip) => Preparation.prepareExperienceSkippable(itemData, skip),
		messages: [
			'Hast du bereits Erfahrung für bestimmte Rechtstätigkeiten gesammelt?'
		],
	},
	[Section.EXPERIENCE_FUNCTION_MARKETING_ROLE]: {
		property: 'experienceFunctionMarketingRole',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData, skip) => Preparation.prepareExperienceSkippable(itemData, skip),
		messages: [
			'Hast du bereits Erfahrung für bestimmte Marketingtätigkeiten gesammelt?'
		],
	},
	[Section.EXPERIENCE_FUNCTION_TAX_FIELD]: {
		property: 'experienceFunctionTaxField',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData, skip) => Preparation.prepareExperienceSkippable(itemData, skip),
		messages: [
			'Hast du bereits Erfahrung in bestimmten Steuergebieten gesammelt?'
		],
	},
	[Section.EXPERIENCE_FUNCTION_TAX_ROLE]: {
		property: 'experienceFunctionTaxRole',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData, skip) => Preparation.prepareExperienceSkippable(itemData, skip),
		messages: [
			'Hast du bereits Erfahrung für bestimmte Steuertätigkeiten gesammelt?'
		],
	},
	[Section.EXPERIENCE_CAREER_LEVEL]: {
		property: 'experienceCareerLevel',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData, skip) => Preparation.prepareExperienceSkippable(itemData, skip),
		showSkipWarning: true,
		messages: [
			'Hast du Arbeitserfahrung, wie zum Beispiel Praktikum, Lehre, als Mitarbeiter, Spezialist oder in Projektleitung, Teamleitung, im Management usw.?',
		],
	},
	[Section.PARKING]: {
		property: 'parking',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareParking(itemData),
		messages: [
			'Brauchst du einen Parkplatz beim Arbeitsplatz?',
		],
	},
	[Section.EXPERIENCE_INDUSTRIAL_SECTOR]: {
		property: 'experienceIndustrialSector',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData, skip) => Preparation.prepareExperienceSkippable(itemData, skip),
		messages: [
			'In welchen Branchen waren deine bisherigen Arbeitgeber tätig? Welche Produkte oder Leistungen wurden dort angeboten?',
			'Gib alle deine Erfahrungen an. Das erhöht deine Chancen!'
		],
	},
	[Section.COMPANY_TYPE]: {
		property: 'companyType',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData),
		messages: [
			'Bevorzugst du bestimmte Unternehmen / Organisationen als Arbeitgeber?',
		],
	},
	[Section.COMPANY_SIZE]: {
		property: 'companySize',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData),
		messages: [
			'Ist dir eine bestimmte Größe des Unternehmens / der Organisation deines Arbeitgebers wichtig?',
		],
	},
	[Section.MANAGEMENT]: {
		property: 'management',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareDesireExperience(itemData),
		messages: [
			'Würdest du auch Mitarbeiter führen?',
		],
	},
	[Section.OVERTIME]: {
		property: 'overtime',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Würdest du Überstunden machen, wenn der Job dir gefällt?',
		],
	},
	[Section.WORKING_TIME]: {
		property: 'workingTime',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareWorkingTime(itemData),
		messages: [
			'Wären für dich spezielle Arbeitszeiten in Ordnung?',
		],
	},
	[Section.LANGUAGES]: {
		property: 'languages',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData),
		messages: [
			'你说日语吗?',
			'Sorry, kleiner Scherz... ;)',
			'Welche Sprachen kannst du?',
		],
	},
	[Section.SKILLS_SOFTWARE_MAIN]: {
		property: 'skillsSoftwareMain',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData),
		messages: [
			'Welche Büro-Software kannst du anwenden?',
		],
	},
	[Section.SKILLS_SOFTWARE_SPECIAL]: {
		property: 'skillsSoftwareSpecial',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData),
		messages: [
			'Mit welcher speziellen Software kennst du dich aus?',
		],
	},
	[Section.CUSTOMER_CONTACT]: {
		property: 'customerContact',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareDesireExperience(itemData),
		messages: [
			'Hast du gerne Kundenkontakt?',
			'Wähle aus, ob du gerne Kontakt hast zu Menschen, die etwas von deinem neuen Arbeitgeber brauchen, das sind Kunden oder Klienten oder Patienten, Parteien oder Interessenten, Antragsteller, Bürger, ...'
		],
	},
	[Section.DRIVING_LICENSE]: {
		property: 'drivingLicense',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData),
		messages: [
			'Besitzt du einen Führerschein?',
		],
	},
	[Section.PILOT_LICENSE]: {
		property: 'pilotLicense',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData),
		messages: [
			'Kannst du fliegen?',
		],
	},
	[Section.COMPANY_CAR]: {
		property: 'companyCar',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Möchtest du ein Firmenauto?',
		],
	},
	[Section.PUBLIC_TRANSPORT]: {
		property: 'publicTransport',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Welche Anbindung(en) öffentlicher Verkehrsmittel willst du?',
		],
		prepare: (itemData) => Preparation.preparePublicTransport(itemData),
	},
	[Section.PRIVATE_VEHICLE_COMPANY_USAGE]: {
		property: 'privateVehicleCompanyUsage',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Würdest du dein Privat-Auto (solltest du eines haben) auch für berufliche Fahrten verwenden - gegen entsprechende Abrechnung?',
		],
	},
	[Section.SALARY]: {
		property: 'salary',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Wie viel möchtest du verdienen?',
		],
	},
	[Section.HOURLY_RATE]: {
		property: 'hourlyRate',
		persistType: PERSIST_TYPE__JOB,
		messages: [
			'Welchen Mindest-Stundensatz hättest du gerne?',
		],
	},
	[Section.SKILLS]: {
		property: 'skills',
		persistType: PERSIST_TYPE__APPLICANT,
		prepare: (itemData) => Preparation.prepareCharacteristic(itemData),
		messages: [
			'Welche Persönlichkeitseigenschaften und sozialen Kompetenzen bringst du mit?',
		],
	},
	[Section.TRAVEL_WILLINGNESS]: {
		property: 'travelWillingness',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareTravelWillingness(itemData),
		messages: [
			'Beruflich in die Karibik? &#127796;',
			'Wer weiß, alles ist möglich - reist du gerne?',
		],
	},
	[Section.RELOCATION]: {
		property: 'relocation',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareRelocation(itemData),
		messages: [
			'Würdest du für deinen Traumjob übersiedeln?',
		],
	},
	[Section.SEARCH_STATUS]: {
		property: 'searchStatus',
		persistType: PERSIST_TYPE__JOB,
		prepare: (itemData) => Preparation.prepareSearchStatus(itemData),
		messages: [
			'Wie aktiv suchst du?',
		]
	},
	[Section.EDUCATION]: {
		property: 'education',
		persistType: PERSIST_TYPE__APPLICANT,
		showSkipWarning: true,
		messages: [
			'Zuletzt: Gib noch deine höchste <b>abgeschlossene</b> Ausbildung an.',
		],
		prepare: (itemData, skip) => Preparation.prepareCareerQuestionnaire(itemData, skip)
	},
	[Section.LEGITIMATION]: {
		property: 'legitimation',
		persistType: PERSIST_TYPE__APPLICANT,
		messages: [],
		trackingEventLabel: 'Sicherheitscode Seite GEÖFFNET'
	},
};

export default {

	components: {
		JonInfo,
		PopUp,
		Avatar,
		Jon,
		Education,
		Label,
		BreakDisplay,
		CareerChangeFunction,
		CareerChangeIndustrialSector,
		Parking,
		DesireAdditions,
		DesireExperience,
		EmploymentDuration,
		SkillsSoftwareSpecial,
		Legitimation,
		WorkingHours,
		SearchStatus,
		Relocation,
		ExternalSleepover,
		TravelWillingness,
		Skills,
		Salary,
		HourlyRate,
		CompanyCar,
		PublicTransport,
		CustomerContact,
		Languages,
		WorkingTime,
		PrivateVehicleCompanyUsage,
		SelectInline,
		StartDate,
		Experience,
		Loading,
		CharacteristicEdit,
		Overtime,
		Button,
		Icon,
	},

	data ()
	{
		return {
			questionnaire: undefined,
			loading: true,
			finishingItem: false,
			indexToEdit: undefined,
			allDone: false,
			publishedJob: false,
			itemData: {},
			labelTypeApplication: CharacteristicLabel.APPLICATION,
			confirmMobilePhone: undefined,
			breakType: undefined,
			skip: false,
			skipped: [],
			disabledSkips: [],
			seenIndexes: new Set(),
			showMessages: true,
			showSkipWarningPopUp: false
		};
	},

	computed: {
		...mapState('job/bot', {
			show: 'showQuestionnaire',
			job: 'job',
			postFinish: 'postFinish'
		}),
		...mapState('meta', ['meta']),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['job-bot-questionnaire']
			});
		},
		functionSupplementTypes ()
		{
			return RELEVANT_SUPPLEMENT_TYPES;
		},
		avatarRocket ()
		{
			return ROCKET;
		},
		employmentModes ()
		{
			return _.map(this.job.employmentMode, 'item');
		},
		isLegitimation ()
		{
			const item = this.indexToEdit >= 0
				? this.questionnaire.items[this.indexToEdit]
				: null;

			return item?.id === Section.LEGITIMATION;
		},
		hasUnfinishedPreListingItems ()
		{
			if (!this.questionnaire)
			{
				return true;
			}

			let hasUnfinishedItems = false;

			_.forEach(this.questionnaire.items, (item, i) =>
			{
				// is pre listing item AND
				// has no item data OR is currently being edited
				if (item.preListing && (this.getItemData(i) === undefined || this.indexToEdit === i))
				{
					hasUnfinishedItems = true;

					return false; // break
				}
			});

			return hasUnfinishedItems;
		},
		allItemDataValid ()
		{
			let valid = true;

			_.forEach(_.range(0, this.indexToEdit + 1, 1), i =>
			{
				const item = this.questionnaire.items[i];

				if (item.id === Section.LEGITIMATION) // skip legitimation, can not have data
				{
					return true; // continue
				}

				if (this.getItemDataByIndex(i) === undefined && !_.includes(this.skipped, item.id))
				{
					valid = false;
					return false; // break
				}
			});

			return valid;
		},
		hideGoBack ()
		{
			const item = this.questionnaire.items[this.indexToEdit - 1];

			return item?.id === Section.LEGITIMATION;
		},
		canGoBack ()
		{
			return this.indexToEdit > 0;
		},
		canSkip ()
		{
			if (this.allDone || this.breakType || this.postFinish)
			{
				return false;
			}

			if (this.indexToEdit >= 0)
			{
				const isSkipped = _.includes(this.disabledSkips, this.questionnaire.items[this.indexToEdit].id);

				if (isSkipped)
				{
					return false;
				}
			}

			const item = this.questionnaire.items[this.indexToEdit];

			return item && !item.preListing && this.getItemData(item.id) === undefined;
		},
		canContinue ()
		{
			if (this.canSkip && this.skip)
			{
				return true;
			}

			if (this.breakType)
			{
				return true;
			}

			return this.allItemDataValid;
		},
		forcedMessages ()
		{
			if (!this.confirmMobilePhone)
			{
				return undefined;
			}

			const mobilePhoneNumber = this.confirmMobilePhone.mobilePhoneNumber;

			const phoneNumber = '+' + mobilePhoneNumber.countryCode + ' '
				+ mobilePhoneNumber.number;

			return [
				'SMS für dich!',
				'Wir haben dir eine SMS gesendet an deine Mobilnummer: ' + phoneNumber
			];
		}
	},

	methods: {
		...mapActions('job/bot', [
			'closeQuestionnaire'
		]),
		onDesireAdditionsEdit ()
		{
			this.$nextTick(() =>
			{
				this.scrollToBottom();
			});
		},
		scrollToBottom ()
		{
			scrollToBottom(this.$refs.main);
		},
		scrollToTop ()
		{
			this.$refs.main.scrollTop = 0;
		},
		close ()
		{
			Object.assign(this.$data, this.$options.data.apply(this));

			Event.push(
				new EventData()
					.setEvent(Event.PAGE_VISIT)
					.setAction('Matches')
			);

			this.closeQuestionnaire();
		},
		isItemToEdit (itemId, loopIndex)
		{
			const index = _.findIndex(this.questionnaire.items, i => i.id === itemId);

			if (index < 0 || index !== loopIndex)
			{
				return false;
			}

			// is editable if already seen once
			return index <= this.indexToEdit || this.seenIndexes.has(index);
		},
		getItemData (itemId)
		{
			const index = _.findIndex(this.questionnaire.items, i => i.id === itemId);

			return index >= 0 ? this.getItemDataByIndex(index) : undefined;
		},
		getItemDataByIndex (index)
		{
			return this.itemData[index];
		},
		setItemData (itemId, data)
		{
			const index = _.findIndex(this.questionnaire.items, i => i.id === itemId);

			if (index >= 0)
			{
				this.$set(this.itemData, index, data);
			}
		},
		getMessages (id)
		{
			return CONFIG[id].messages;
		},
		desireAdditionsFurtherAppeared (id, eventData)
		{
			if (!eventData.hasData)
			{
				this.showMessages = false;
			}

			this.addDisableSkip(id);
		},
		addDisableSkip (id)
		{
			if (!_.includes(this.disabledSkips, id))
			{
				this.disabledSkips.push(id);
			}
		},
		removeDisableSkip (id)
		{
			this.disabledSkips = _.filter(this.disabledSkips, innerId => innerId !== id);
		},
		onEducationsChanged ({educationsCount})
		{
			if (educationsCount > 0)
			{
				this.addDisableSkip(Section.EDUCATION);
			}
			else
			{
				this.removeDisableSkip(Section.EDUCATION);
			}

			this.$nextTick(() =>
			{
				this.scrollToBottom();
			});
		},
		goBack ()
		{
			if (!this.canGoBack)
			{
				return;
			}

			this.indexToEdit = this.indexToEdit - 1;
			this.skip = false;

			const item = this.questionnaire.items[this.indexToEdit];

			this.skipped = _.filter(this.skipped, id => id !== item.id);

			this.showMessages = true;

			this.trackCurrentItem();

			this.$nextTick(() => this.scrollToTop());
		},
		async loadQuestionnaireData ()
		{
			this.loading = true;

			const response = await new Get()
				.setJobId(this.job.id)
				.call();

			this.questionnaire = response.data;

			this.indexToEdit = 0;

			this.loading = false;
		},
		onAcceptSkipWarning ()
		{
			this.skip = false;
			this.showSkipWarningPopUp = false;
		},
		onCancelSkipWarning ()
		{
			this.showSkipWarningPopUp = false;

			this.finishItem(false);
		},
		async finishItem (doSkipWarningCheck)
		{
			if (!this.canContinue)
			{
				return;
			}

			if (this.breakType)
			{
				this.breakType = undefined;
				this.trackCurrentItem();
				return;
			}

			try
			{
				const currentItem = this.questionnaire.items[this.indexToEdit];

				const config = CONFIG[currentItem.id];

				const itemData = this.getItemData(currentItem.id);

				const isSkip = itemData?.skipped === true || this.skip;

				if (config.showSkipWarning && isSkip && doSkipWarningCheck)
				{
					this.showSkipWarningPopUp = true;
					return;
				}

				if (this.skip && !_.includes(this.skipped, currentItem.id))
				{
					this.skipped.push(currentItem.id);
				}

				this.finishingItem = true;

				let jobData = {};
				let hasJobData = false;

				let applicantSkillsData = {};
				let hasApplicantSkillsData = false;

				_.forEach(_.range(0, this.indexToEdit + 1, 1), i =>
				{
					const item = this.questionnaire.items[i];

					const config = CONFIG[item.id];

					let itemData;

					if (currentItem && currentItem.id === item.id && this.skip)
					{
						itemData = {
							skipped: true
						};
					}
					else
					{
						itemData = this.getItemData(item.id);

						if (config.prepare)
						{
							itemData = config.prepare(itemData, this.skip);
						}
					}

					if (config.persistType === PERSIST_TYPE__JOB)
					{
						jobData[config.property] = itemData;
						hasJobData = true;
					}

					if (config.persistType === PERSIST_TYPE__APPLICANT)
					{
						applicantSkillsData[config.property] = itemData;
						hasApplicantSkillsData = true;
					}
				});

				if (hasJobData)
				{
					await new JobSave()
						.setJobId(this.job.id)
						.setData(jobData)
						.call();
				}

				if (hasApplicantSkillsData)
				{
					await new ApplicationSkillsSave()
						.setData(applicantSkillsData)
						.call();
				}

				if (currentItem)
				{
					Event.push(
						new EventData()
							.setEvent(Event.QUESTIONNAIRE)
							.setAction(
								this.skip
									? 'Weiter (Überspringen)'
									: 'Weiter'
							)
							.setName(this.getTrackingEventLabel(currentItem))
					);
				}

				this.$nextTick(() =>
				{
					this.scrollToTop();
				});

				this.increaseIndex();

				this.finishingItem = false;
				this.skip = false;
				this.showMessages = true;
			}
			catch (e)
			{
				Log.error(e);

				Toast.error(this, flatten(e.errors));
			}
		},
		increaseIndex ()
		{
			this.indexToEdit = this.indexToEdit + 1;

			this.seenIndexes.add(this.indexToEdit);

			const item = this.questionnaire.items[this.indexToEdit];

			// all done
			if (!item)
			{
				if (this.postFinish)
				{
					this.close();
				}
				else
				{
					this.allDone = true;

					Event.push(
						new EventData()
							.setEvent(Event.QUESTIONNAIRE)
							.setAction('Yeah, alles erledigt')
					);
				}
			}
			else
			{
				if (!this.breakType)
				{
					this.trackCurrentItem();
				}
			}
		},
		onFinishLegitimation ({publishedJob})
		{
			this.confirmMobilePhone = false;
			this.publishedJob = publishedJob;

			Event.push(
				new EventData()
					.setEvent(Event.QUESTIONNAIRE)
					.setAction('Gratuliere + weitere Infos erforderlich für Matching')
			);

			this.breakType = TYPE__PRE_EXPERIENCE;
			this.increaseIndex();
		},
		continueLater ()
		{
			this.closeQuestionnaire({
				continueLater: true
			});
		},
		trackCurrentItem ()
		{
			if (!this.questionnaire?.items)
			{
				return;
			}

			const item = this.questionnaire.items[this.indexToEdit];

			if (!item)
			{
				return;
			}

			Event.push(
				new EventData()
					.setEvent(Event.QUESTIONNAIRE)
					.setAction('Aufruf')
					.setName(this.getTrackingEventLabel(item))
			);
		},
		getTrackingEventLabel (item)
		{
			return CONFIG[item.id]?.trackingEventLabel ?? item.sectionLabel ?? item.id;
		}
	},

	watch: {
		async show (show)
		{
			if (show)
			{
				await this.loadQuestionnaireData();

				this.trackCurrentItem();
			}
		}
	}
}
</script>
